"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
    clearPersist
    Utitlity function that clears or resets state that is marked with persist.
*/

var clearPersist = function clearPersist(key) {
  localStorage.removeItem(key);
};

var _default = clearPersist;
exports["default"] = _default;
module.exports = exports["default"];